import React from 'react';

import { DetectionIcon } from '@vlabs/icons';
import { TypeCard, TypeIcon } from '@vlabs/monokit/shared/ui/type-card';
import { useModal } from '@vlabs/uikit';

import { BiometricIdentificationForm } from './BiometricIdentificationForm';
import type { BiometricIdentificationFormValues } from './BiometricIdentificationForm';
import { CreatedHandlerModal } from './CreatedHandlerModal';
import { biometricIdentification } from './handlerFactories.js';
import { useCreateHandlerTranslation } from './i18n';
import { useCreateHandlerWithResult } from './useCreateHandlerWithResult';

function BiometricIdentificationCard(): React.JSX.Element {
  const { t } = useCreateHandlerTranslation();
  const formModal = useModal({ size: 'small' });
  const {
    closeResult, createHandler, createdHandler,
  } = useCreateHandlerWithResult();

  const onSubmit = async (values: BiometricIdentificationFormValues) => {
    await createHandler(
      values,
      biometricIdentification as (handlerValues: BiometricIdentificationFormValues) => unknown,
    );
    formModal.close();
  };

  return (
    <React.Fragment>
      {formModal.wrap(
        <BiometricIdentificationForm
          onSubmit={onSubmit}
        />,
      )}
      <CreatedHandlerModal
        handlerId={createdHandler?.handlerId}
        handlerName={createdHandler?.handlerName}
        onClose={closeResult}
      />
      <TypeCard
        data-testid="handler.biometricIdentification"
        description={t('cards.biometric.description')}
        icon={(
          <TypeIcon variant="secondary">
            <DetectionIcon />
          </TypeIcon>
        )}
        onClick={formModal.open}
        title={t('cards.biometric.title')}
      />
    </React.Fragment>
  );
}

export { BiometricIdentificationCard };
